import React from 'react'
import checkmarkIconSrc from './checkmark.svg'
import ConditionalRender from 'components/ConditionalRender'
import './style.css'

const AccordionHeader = ({ stepId, name, isCheckedOff }) => (
  <div className="app-submit-view-accordion-header">
    <span className="app-submit-view-accordion-header-step-id">
      {stepId}
    </span>
    <span className="app-submit-view-accordion-header-step-name">
      {name}
    </span>
    <ConditionalRender condition={isCheckedOff}>
      <img
        className="app-submit-view-accordion-header-step-checkmark"
        src={checkmarkIconSrc} alt="checkmark"
      />
    </ConditionalRender>
  </div>
)

export default AccordionHeader
